import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import ResellerLayout from '../components/ResellerLayout';
import { fetchResellerOrders, type MyOrder } from '@/lib/myAccount';

const statusColors: Record<string, string> = {
  pending: 'bg-[#F0EFED] text-[#8A8A8A]',
  paid: 'bg-[#7B1113]/10 text-[#7B1113]',
  shipped: 'bg-[#1E3A8A]/10 text-[#1E3A8A]',
  delivered: 'bg-green-100 text-green-700',
  cancelled: 'bg-gray-100 text-gray-500',
};

export default function ResellerOrdersPage() {
  const { resellerProfile } = useAuth();
  const [orders, setOrders] = useState<MyOrder[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!resellerProfile) return;
    fetchResellerOrders(resellerProfile.id).then((rows) => {
      setOrders(rows);
      setLoading(false);
    });
  }, [resellerProfile]);

  return (
    <ResellerLayout title="Order History">
      <div className="bg-white rounded-2xl border border-[#E8E8E6] overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-sm text-[#8A8A8A]">Loading…</div>
        ) : orders.length === 0 ? (
          <div className="p-10 text-center text-sm text-[#8A8A8A]">No orders yet</div>
        ) : (
          <div className="flex flex-col">
            {orders.map((order) => (
              <div key={order.id} className="flex items-center justify-between px-6 py-5 border-b border-[#E8E8E6] last:border-0">
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-[#2A2A2A]">{order.orderNo}</span>
                  <span className="text-xs text-[#8A8A8A]">{order.placedAt.slice(0, 10)}</span>
                  <span className="text-xs text-[#8A8A8A]">{order.items.map((i) => `${i.name} ×${i.qty}`).join(', ')}</span>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded-full ${statusColors[order.status]}`}>{order.status}</span>
                  <span className="text-sm font-medium text-[#2A2A2A]">৳{order.totalBdt.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </ResellerLayout>
  );
}
